export default __webpack_public_path__ + "static/media/doodle_large.3eb3e68d.png";